// eslint-disable-next-line no-use-before-define
import React, { FunctionComponent, useEffect } from "react";
import {
  SelectFieldProps,
  SelectOptions,
} from "../../../interfaces/components/form.interface";

const CheckoutSelectComponent: FunctionComponent<SelectFieldProps> = ({
  label,
  id,
  options,
  disabled,
  placeholder,
  onChangeHandler,
  value,
  required,
  className,
}: SelectFieldProps) => {
  //  value of changeEventHandler
  const [_value, setValue] = React.useState(value);

  const changeEventHandler = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    const currentTarget: string = event.currentTarget?.value;
    if (currentTarget) {
      const getValueFromOptions = options.find((r) => r.id === currentTarget);
      setValue({ id: "", value: currentTarget });
      if (onChangeHandler && getValueFromOptions) {
        onChangeHandler(getValueFromOptions);
      }
    }
  };

  useEffect(() => {
    const isValueExist = options.find((r) => r.id === value?.id);
    if (isValueExist) setValue(isValueExist);
  }, [value, options]);

  return (
    <div className={`selectInput__wrapper`} data-test="inputSelect-wrapper">
      {label && (
        <label
          className="selectInput__label"
          htmlFor={id}
          data-test="inputSelect-label"
        >
          {label}
        </label>
      )}
      <select
        className={`selectInput__select ${className}`}
        value={_value?.id}
        id={id}
        data-test="inputSelect-select"
        disabled={disabled}
        // placeholder={placeholder}
        onChange={changeEventHandler}
        required={required}
      >
        {options.map((item: SelectOptions) => (
          <option
            key={item.id}
            value={item.id}
            disabled={item.disabled}
            selected={item.isDefault}
          >
            {item.value}
          </option>
        ))}
      </select>
    </div>
  );
};
export default CheckoutSelectComponent;
